import { render, staticRenderFns } from "./device-info-detail.vue?vue&type=template&id=8f8d99a6&scoped=true&"
import script from "./device-info-detail.vue?vue&type=script&lang=ts&"
export * from "./device-info-detail.vue?vue&type=script&lang=ts&"
import style0 from "./device-info-detail.vue?vue&type=style&index=0&id=8f8d99a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8d99a6",
  null
  
)

export default component.exports